$(document).ready(function () {
    let techDetailNo = $('.tech-overview').data('techdetailno');

    // Check if the index is set in the URL
    let url = new URL(window.location.href);
    let index = url.searchParams.get("index");
    if(index !== null) {
        loadTechOverviewData(techDetailNo, index);
    }

    addHeaderClickEvent(techDetailNo);

    window.addEventListener('popstate', (event) => {
        const url = new URL(window.location.href);
        const index = url.searchParams.get("index");
        loadTechOverviewData(techDetailNo, index);
    });

    // Handle search
    let searchOverviewInput = document.getElementById('searchOverview');
    let debounceTimeout;
    searchOverviewInput.addEventListener('keyup', function() {
        let index = $('.tech-overview .overview-index.selected').data('index');
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function() {
            loadTechOverviewData(techDetailNo, index, true);
        }, 700);
    });
});

function loadTechOverviewData(techDetailNo, index, blnSearch = false){
    // Add the selected class to the clicked index and remove it from the others
    $('.tech-overview .overview-index').not('[data-index=' + index + ']').removeClass('selected');
    $('.tech-overview .overview-index[data-index=' + index + ']').addClass('selected');

    // Add loader
    $('.tech-overview-data').html('<div class=\'wrap\'><div class=\'mini-cart-loader\'><img src=\'' + strPath + 'images/css/ajax-loader.gif\' alt=\'\' title=\'\' /></div></div>');

    // Check if a search string was entered
    let searchOverviewInput = document.getElementById('searchOverview');
    let search = searchOverviewInput.value ? encodeURIComponent(searchOverviewInput.value.toLowerCase()) : '';

    // Do ajax call to replace the tech overview data
    $.get(strAjaxPath + 'get-tech-overview-data.php', 'techdetailno=' + techDetailNo + '&index=' + index + '&search=' + search + '&frmSearch=' + (blnSearch ? '1' : '0'), function (data) {
        // Parse the JSON response
        let response = JSON.parse(data);

        if((search !== "" || blnSearch) && response.techOverviewHeader){
            $('.tech-overview .tech-overview-header').html(response.techOverviewHeader);
            addHeaderClickEvent(techDetailNo);
        }

        $('.tech-overview-data').html(response.techOverviewData);
    });
}

function addHeaderClickEvent(techDetailNo){
    $('.tech-overview .overview-index:not(.disabled)').click(function () {
        let index = $(this).data('index');

        let url = new URL(window.location.href);
        url.searchParams.set("index", index);
        window.history.pushState({}, '', url);

        loadTechOverviewData(techDetailNo, index);
    });
}
